import './App.css';
import Header from './components/Header'
import Portada from './components/Portada'
import Planes from './components/Planes'
import Ademas from './components/Ademas'
import Footer from './components/Footer'
import BotonFlotante from './components/boton-flotante/BotonFlotante'
import { useState } from 'react';

function App() {

  const [inputFocus, setInputFocus] = useState(null)

  const onWAClick = () => {
    window.gtag('event', 'conversion', { 'send_to': 'AW-652151810/Ls6iCPCE7v8BEIKY_LYC' })
    window.fbq('trackCustom', 'ClickWhatsapp', { origen: '/fibraoptica' })
  }

  return (
    <div className="App">

      <Header />

      <Portada focus={inputFocus} />

      <Planes setFocus={setInputFocus} />

      <Ademas />

      <Footer />

      <BotonFlotante />

      <a className="App-wa" href='https://api.whatsapp.com/send?phone=5491121614999&text=Quiero%20recibir%20m%C3%A1s%20informaci%C3%B3n%20acerca%20de%20Claro%20Fibra%20%C3%93ptica%20para%20el%20Hogar...' target="_blank" rel="noreferrer" onClick={onWAClick}><img src={process.env.PUBLIC_URL + '/imgs/wa.svg'} alt="WhatsApp" /></a>
    </div>
  );
}

export default App;